import styled from 'styled-components';

interface CenterContentProps {
    expanded?: boolean;
}

const CenterContent = styled.div<CenterContentProps>`
    padding: 0 2.5rem;
    margin: 0 auto;
    max-width: 144rem;
    @media (max-width: 50rem) {
        max-width: 100rem;
    }
`;

export default CenterContent;
